export const RESET_PWD_DONE =
  "Your password has been sent to your registered email address.";
export const INCORRECT_CREDENTIALS =
  "Please enter valid login credentials and try again.";
export const FORGOT_INCORRECT_CREDENTIALS =
  "Please enter valid details and try again.";
export const UNLOCK_LESSON_POD =
  'Are you sure you want to unlock this Lesson pod? Clicking "OK" will erase your work on all other devices.';
export const NOTHING_FOR_REPLAY = "There is nothing to replay.";
export const SEQUENCE_TYPE = "Type answer and hit tab to go to the next field";
export const SEQUENCE_SELECT = "Select answer to go to the next field";
export const NAVIGATION_PAPER =
  "Type or Select answer and hit tab to go to the next field";
export const EXCERCISE_SAVED = "Exercise saved successfully.";
export const DONE_CONFIRMATION = "Do you want to mark this activity as done?";
export const DONE_CONTAINED =
  "Saving this activity will make all the marker activities as Done.";
export const RESET_CONFIRMATION =
  "Do you want to clear your work and reset this activity?";
export const NOT_SKIPPED = "The last item cannot be skipped";
export const TILE_MATCHED = "Item already matched with tile!";
export const ERROR_HAPPENED =
  "Your request could not be processed. Please try again or contact your administrator.";
export const CLOSE_CONFIRMATION = "Do you want to save the progress?";
export const RESUME_VIDEO = "Resuming Video";
export const RECORD_CONFIRMATION = "Do you want to save this audio?";
export const RECORD_DELETE = "Do you want to delete this audio?";
export const ID_PREFIX_FILE = "ST-REC";
export const RECORD_ONGOING = "Recording is in progress";
export const RECORD_OVERWRITE = "Do you want to overwrite previous audio?";

export const SMART_PAPER = "SmartPaper";
export const SMART_TILE = "SmartTiles";
export const SMART_SLIDE = "SmartSlide";
export const SMART_LABEL = "SmartLabel";
export const SMALL_DESKTOP = "18px";
export const MEDIUM_DESKTOP = "20px";
export const LARGE_DESKTOP = "22px";
export const XLARGE_DESKTOP = "24px";
export const SMALL = "16px";
export const MEDIUM = "18px";
export const LARGE = "20px";
export const MAX_QUESTION_HEIGHT = "36%";
export const MIN_QUESTION_HEIGHT = "10%";
export const MAX_CANVAS_HEIGHT = "64%";

//Service contants
export const TOKEN_EXPIRED = "Token Expired";
export const REFRESH_FAILED = "Token Refresh Failed";
export const INVALID_REFRESH = "Invalid refresh token.";

//Refresh services call constants
export const GET_COURSES = "getCourses";
export const GET_CHAPTERS = "getChapters";
export const GET_FOLDERS = "getFolders";
export const GET_LESSONS = "getLessons";
export const GET_LESSON_UNITS = "getLessonUnits";
export const GET_UPCOMIN_ASSIGN_LIST = "getUpcomingAssignList";
export const GET_ACTIVITY = "getActivity";
